import produce from 'immer';

import { Action } from '../../actions';
import { ImageUploaderState, State } from '../../typings/state';

import {
    HIDE_IMAGE_UPLOADER_LOADER,
    INIT_IMAGE_UPLOADER,
    RESET_IMAGE_UPLOADER_CHANGES,
    SHOW_IMAGE_UPLOADER_LOADER,
    UPLOAD_IMAGE_UPLOADER_IMAGE_SUCCESS
} from './actions';

export const imageUploaderInitialState: ImageUploaderState = {};

export function imageUploaderReducer(
    state: ImageUploaderState = imageUploaderInitialState,
    action: Action,
    fullState: State
): ImageUploaderState {
    switch (action.type) {
        case INIT_IMAGE_UPLOADER:
            return produce(state, draftState => {
                if (!draftState[action.resourcesId]) {
                    draftState[action.resourcesId] = {
                        upload: false,
                        resetEnabled: false,
                        sourceImageUrl: ''
                    };
                }

                draftState[action.resourcesId].sourceImageUrl = action.imageUrl;
                draftState[action.resourcesId].imageUrl = action.imageUrl;
            });

        case RESET_IMAGE_UPLOADER_CHANGES:
            return produce(state, draftState => {
                draftState[action.resourcesId].imageUrl = state[action.resourcesId].sourceImageUrl;
                draftState[action.resourcesId].resetEnabled = false;
            });

        case SHOW_IMAGE_UPLOADER_LOADER:
            return produce(state, draftState => {
                draftState[action.resourcesId].upload = true;
            });

        case HIDE_IMAGE_UPLOADER_LOADER:
            return produce(state, draftState => {
                draftState[action.resourcesId].upload = false;
            });

        case UPLOAD_IMAGE_UPLOADER_IMAGE_SUCCESS:
            return produce(state, draftState => {
                draftState[action.resourcesId].imageUrl = action.imageUrl;
                draftState[action.resourcesId].resetEnabled = true;
            });

        default:
            return state;
    }
}
